import React from "react";
import { Controller } from "react-hook-form";
import Select from "react-select";
import { ErrorText } from "../styles";

function CustomSelect({
  placeholder = "",
  rules = {},
  options = [],
  name = "",
  handleChange = null,
  isDisabled = false,
  defaultValue = "",
  maxWidth = "",
}) {
  return (
    <Controller
      name={name}
      rules={{ ...rules }}
      defaultValue={defaultValue}
      render={({ field, fieldState }) => {
        const selected = field.value;

        const isError = fieldState?.error && !selected;
        return (
          <div>
            <Select
              {...field}
              options={options}
              isClearable
              isDisabled={isDisabled}
              styles={{
                control: (base) => ({
                  ...base,
                  borderColor: isError ? "#e6000f" : "#e5e7eb",
                  boxShadow: "none",
                  "&:hover": {
                    borderColor: isError ? "#e6000f" : "#e5e7eb",
                  },
                  backgroundColor: "white",
                  boxShadow: "none",
                  outline: "none",
                  cursor: "pointer",
                  height: "48px",
                  fontSize: 14,
                }),
                option: (base, state) => ({
                  ...base,
                  backgroundColor: state.isSelected
                    ? " #e5e7eb"
                    : state.isFocused
                    ? "#f5f5f5"
                    : "transparent",
                  color: "#1f2937",
                  cursor: "pointer",
                  fontSize: 14,
                  lineHeight: "18px",
                  "&:hover": {
                    backgroundColor: "#e5e7eb",
                  },
                }),
                valueContainer: (base) => ({
                  ...base,
                  maxWidth,
                  fontSize: 14,
                }),
                singleValue: (base) => ({
                  ...base,
                  fontSize: 14,
                }),
                placeholder: (base) => ({
                  ...base,
                  fontSize: 14,
                }),
                input: (base) => ({
                  ...base,
                  fontSize: 14,
                }),
              }}
              components={{
                IndicatorSeparator: () => null,
              }}
              className="basic-single"
              classNamePrefix="select"
              placeholder={placeholder}
              onChange={(option) => {
                field.onChange(option);
                if (typeof handleChange === "function") {
                  handleChange(option);
                }
              }}
            />

            <ErrorText error={isError}>
              {isError ? fieldState.error?.message : "error placeholder"}
            </ErrorText>
          </div>
        );
      }}
    />
  );
}

export default CustomSelect;
